<template>
  <div>
    <v-card-actions v-if="!control.terminer">
      <v-btn
        v-if="control.droitTraitement"
        text
        @click="control.dialogValider = true"
        color="primary"
      >
        Valider
      </v-btn>
      <v-btn
        v-if="control.droitTraitement"
        text
        @click="control.dialogRefuser = true"
      >
        Refuser
      </v-btn>

      <v-btn
        v-if="control.droitTraitement && control.complementsPossible"
        text
        @click="ouvrirDemandeComplement"
      >
        Demander complément
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="control.dialogDemander" persistent max-width="50%">
      <v-card>
        <v-card-title class="info white--text">
          <v-icon color="white">mdi-comment-alert</v-icon> Demander un
          complément d'information
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Veuillez choisir un destinataire pour cette demande.
          </p>

          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                label="Utilisateur AGIL"
                v-model="control.nomUtilisateurAGIL"
                :items="control.listUtilisateurAGIL"
                :item-text="libelle"
                item-value="id"
                dense
                filled
                clearable
              />
            </v-col>
          </v-row>

          <p class="pt-4">
            Veuillez saisir la demande d'information complémentaire pour cette
            demande.
          </p>

          <v-textarea
            v-model="control.commentaireComplement"
            filled
            label="Demande"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="sansCommentaire"
            @click="controlAction.demanderComplement"
            :loading="control.demanderComplement"
          >
            Demander
          </v-btn>
          <v-btn text @click="control.dialogDemander = false">
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="control.dialogValider" persistent max-width="50%">
      <v-card>
        <v-card-title class="accent white--text">
          <v-icon color="white">mdi-alert</v-icon> Validation de la demande
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Vous allez valider cette demande.
          </p>
          <p>
            Êtes-vous sûr de vouloir continuer ?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="controlAction.validerDemande"
            :loading="control.validerDemande"
          >
            Oui
          </v-btn>
          <v-btn text @click="control.dialogValider = false">
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="control.dialogRefuser" persistent max-width="50%">
      <v-card>
        <v-card-title class="accent white--text">
          <v-icon color="white">mdi-alert</v-icon> Refus de la demande
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Vous allez refuser cette demande.
          </p>
          <p>
            Êtes-vous sûr de vouloir continuer ?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              control.dialogRefuser = false;
              control.dialogMotifRefus = true;
            "
          >
            Oui
          </v-btn>
          <v-btn text @click="control.dialogRefuser = false">
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="control.dialogMotifRefus" persistent max-width="50%">
      <v-card>
        <v-card-title class="accent white--text">
          <v-icon color="white">mdi-alert</v-icon> Motif du Refus
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Veuillez saisir le motif de ce refus.
          </p>
          <v-textarea
            counter
            v-model="control.motifRefus"
            filled
            :rules="[size]"
            label="Motif de refus"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="controlAction.refuserDemande"
            :loading="control.refuserDemande"
            :disabled="peutPasValider"
          >
            valider
          </v-btn>
          <v-btn text @click="control.dialogMotifRefus = false">
            annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  inject: ['controlAction', 'control'],
  computed: {
    sansCommentaire() {
      return !this.control.commentaireComplement;
    },
    peutPasValider() {
      if (!this.control.motifRefus) {
        return true;
      } else if (this.control.motifRefus.length > 255) {
        return true;
      } else {
        return false;
      }
    },
    size() {
      if (this.control.motifRefus) {
        return (
          this.control.motifRefus.length <= 255 || 'maximum 255 caractères'
        );
      } else {
        return true;
      }
    },
    libelle() {
      return item => {
        if (item.mailConfidentiel == true) {
          return `${item.nom} ${item.prenoms}`;
        } else {
          return `${item.nom} ${item.prenoms} (${item.mail})`;
        }
      };
    },
  },
  methods: {
    ouvrirDemandeComplement() {
      this.control.commentaireComplement = null;
      this.control.nomUtilisateurAGIL = null;

      this.loadDestinataires().then(() => {
        this.control.dialogDemander = true;
      });
    },
    loadDestinataires() {
      return this.$api('envoi/destinatairesAgilDemandes/list')
        .get()
        .then(response => {
          this.control.listUtilisateurAGIL = response.body;
        });
    },
  },
};
</script>
